import TextAreaField from "../../../../components/Forms/Input/TextAreaField";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const PaymentNotes = ({ value, onChange }: Props) => {
  return (
    <div className="px-6 py-5">
      
      {/* 🔹 Header */}
      <div className="mb-5">
        <h3 className="font-medium text-black dark:text-white">
          Notas
        </h3>
        <p className="text-sm text-graydark dark:text-gray-400">
          Agrega información adicional sobre el pago
        </p>
      </div>

      {/* 🔥 Campo */}
      <TextAreaField
        label="Observaciones"
        name="notes"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Ej: Pago realizado en sucursal, efectivo recibido..."
        rows={3}
        iconKey="note"
      />

      {/* 🔥 Hint */}
      <p className="mt-2 text-xs text-graydark dark:text-gray-400">
        Esta información es opcional y se guardará junto al pago.
      </p>
    </div>
  );
};

export default PaymentNotes;